// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"148f60a8","211":"47aa83f8","281":"15d2a935","344":"f374cf5d","634":"0a5f5fac","683":"46f47d11","787":"6034518f","938":"c657d944"}[chunkId] + ".chunk.js";
};